import {gql} from '@apollo/client';

const GET_CURRENCIES = gql`
  query GetCountryCurrencies {
    countryCurrencies
  }
`;

export default GET_CURRENCIES;
